import { themeColours } from "../../resources";
import "./HomePageGuide.css";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { InfoModal } from "./InfoModal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
const shopPage = require("../../assets/shopPage.png");

export function ShopPageGuide() {
  const [storeCheck, setStoreCheck] = useState<boolean>(localStorage.getItem("storeCheck") === "T");
  const [titleCheck, setTitleCheck] = useState<boolean>(localStorage.getItem("titleCheck") === "T");
  const [catCheck, setCatCheck] = useState<boolean>(localStorage.getItem("catCheck") === "T");
  const [brandCheck, setBrandCheck] = useState<boolean>(localStorage.getItem("brandCheck") === "T");
  const [volumeCheck, setVolumeCheck] = useState<boolean>(localStorage.getItem("volumeCheck") === "T");
  const navigate = useNavigate();
  function handleIconClick(icon: string) {
    switch (icon) {
      case "store":
        localStorage.setItem("storeCheck", "T");
        setStoreCheck(true);
        break;
      case "title":
        localStorage.setItem("titleCheck", "T");
        setTitleCheck(true);
        break;
      case "cat":
        localStorage.setItem("catCheck", "T");
        setCatCheck(true);
        break;
      case "brand":
        localStorage.setItem("brandCheck", "T");
        setBrandCheck(true);
        break;
      case "volume":
        localStorage.setItem("volumeCheck", "T");
        setVolumeCheck(true);
        break;
    }
  }
  function handleSearchClick() {
    localStorage.setItem("searchCheck", "T");
    return navigate("/guide/results");
  }
  return (
    <div className="homePageContainer">
      <img src={shopPage} alt="background" className="background" />
      <InfoModal
        element={
          <span className="infoIcon storeIcon">
            <IoMdInformationCircleOutline size={20} color={storeCheck ? themeColours.secondary : themeColours.green} />
          </span>
        }
        heading={"Stores"}
        texts={[
          <h5 className="modalInfo">
            Select the stores you want to consider in your item search. These will be used in your{" "}
            <strong className="extraBold">item criteria</strong> when adding items to your cart and saving your
            templates.
          </h5>,
        ]}
        onOpenClick={() => handleIconClick("store")}
      />
      <InfoModal
        element={
          <span className="infoIcon titleIcon">
            <IoMdInformationCircleOutline size={20} color={titleCheck ? themeColours.secondary : themeColours.green} />
          </span>
        }
        heading={"Title search"}
        texts={[
          <h5 className="modalInfo">
            Enter the <strong className="extraBold">specific item name</strong> if you only want to look at that item
            across your selected stores.
          </h5>,
          <h5 className="modalInfo">
            If you search this way, the item will be classified as a{" "}
            <strong className="extraBold">specific item</strong> in the shop template.
          </h5>,
        ]}
        onOpenClick={() => handleIconClick("title")}
      />
      <InfoModal
        element={
          <span className="infoIcon catSearchIcon">
            <IoMdInformationCircleOutline size={20} color={catCheck ? themeColours.secondary : themeColours.green} />
          </span>
        }
        heading={"Category search"}
        texts={[
          <h5 className="modalInfo">
            Input the <strong className="extraBold">category</strong> and{" "}
            <strong className="extraBold">sub-category</strong> the item would fall under.
          </h5>,
          <h5 className="modalInfo">
            If you search this way, the item will be classified as a{" "}
            <strong className="extraBold">categorised item</strong> in the shop template.
          </h5>,
        ]}
        onOpenClick={() => handleIconClick("cat")}
      />
      <InfoModal
        element={
          <span className="infoIcon brandIcon">
            <IoMdInformationCircleOutline size={20} color={brandCheck ? themeColours.secondary : themeColours.green} />
          </span>
        }
        heading={"Brands"}
        texts={[
          <h5 className="modalInfo">
            Refine the brands of the item you are considering if you want to{" "}
            <strong className="extraBold">exclude</strong> certain brands.
          </h5>,
        ]}
        onOpenClick={() => handleIconClick("brand")}
      />
      <InfoModal
        element={
          <span className="infoIcon volumeIcon">
            <IoMdInformationCircleOutline size={20} color={volumeCheck ? themeColours.secondary : themeColours.green} />
          </span>
        }
        heading={"Volume"}
        texts={[
          <h5 className="modalInfo">
            Enter a <strong className="extraBold">volume range</strong> for your search in case you are open to buying
            more of the item if you get better value. The <strong className="extraBold">minimum</strong> and{" "}
            <strong className="extraBold">maximum</strong> can be the same if you only want to buy a specific amount.
          </h5>,
        ]}
        onOpenClick={() => handleIconClick("volume")}
      />
      <InfoModal
        element={
          <span className="infoIcon searchIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={localStorage.getItem("searchCheck") === "T" ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Search"}
        texts={[
          <h5 className="modalInfo">
            Search either for <strong className="extraBold">specific</strong> items or with the{" "}
            <strong className="extraBold">category</strong> criteria. Results are returned below.
          </h5>,
        ]}
        buttonText="Learn more"
        onButtonClick={handleSearchClick}
      />
    </div>
  );
}
